import React, { Component,Fragment } from 'react';
import News from './News';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";

class Menu extends Component {
  render () {
    return (
    <Fragment>
      <div>
        <div className='container-fluid bg-3 text-center'>
          <h3>Various Areas of News</h3>
          <br />
          <div className='row'>
            <div className='col-sm-3'>
            <Link to={'/news/business/'+this.props.code}  style={{color:'white',fontSize:'large',textDecoration:'none'}}>
              <button
                className='btn-primary'
                style={{ width: '70%', marginBottom: '2%' }}
              > 
              <img
              src={require('./images/business.jpg')}
              className='img-responsive'
              style={{ width: '100%' }}
              alt='Image1'
              />
               Business News
              </button>
            </Link>
            </div>
            <div className='col-sm-3'>
            <Link to={'/news/entertainment/'+this.props.code} style={{color:'white',fontSize:'large',textDecoration:'none'}}>
              <button
                className='btn-primary'
                style={{ width: '70%', marginBottom: '2%' }}
              > <img
              src={require('./images/entertainment.jpg')}
              className='img-responsive'
              style={{ width: '100%' }}
              alt='Image2'
            />
               Entertainment News
              </button>
              </Link>
            </div>
            <div className='col-sm-3'>
            <Link to={'/news/sports/'+this.props.code} style={{color:'white',fontSize:'large',textDecoration:'none'}}>
              <button
                className='btn-primary'
                style={{ width: '70%', marginBottom: '2%' }}
              ><img
              src={require('./images/sports.jpg')}
              className='img-responsive'
              style={{ width: '100%' }}
              alt='Image3'
            />
               Sports News
              </button>
              </Link>
            </div>
            <div className='col-sm-3'>
            <Link to={'/news/science/'+this.props.code} style={{color:'white',fontSize:'large',textDecoration:'none'}}>
              <button
                className='btn-primary'
                style={{ width: '70%', marginBottom: '2%' }}
              > <img
              src={require('./images/science.png')}
              className='img-responsive'
              style={{ width: '100%' }}
              alt='Image4'
            />
                Science News
              </button>
              </Link>
            </div>
          </div>
        </div>
        <br />
        <div className='container-fluid bg-3 text-center'>
          <div className='row'>
            <div className='col-sm-3'>
            <Link to={'/news/health/'+this.props.code} style={{color:'white',fontSize:'large',textDecoration:'none'}}>
              <button
                className='btn-primary'
                style={{ width: '70%', marginBottom: '2%' }}
              ><img
              src={require('./images/health.png')}
              className='img-responsive'
              style={{ width: '100%' }}
              alt='Image5'
            />
                Health News
              </button>
              </Link>
            </div>
            <div className='col-sm-3'>
            <Link to={'/news/technology/'+this.props.code} style={{color:'white',fontSize:'large',textDecoration:'none'}}>
              <button
                className='btn-primary'
                style={{ width: '70%', marginBottom: '2%' }}
              > <img
              src={require('./images/technology.png')}
              className='img-responsive'
              style={{ width: '100%' }}
              alt='Image6'
            />
              Technology News
              </button>
              </Link>
            </div>
          </div>
        </div>
      
      </div>
      </Fragment>
    )
  }
}

export default Menu
